/**
 * En qué franja de la cuadrícula va una visita — o por qué no va en ninguna
 * (CB-05 B-2).
 *
 * Vive en su propio archivo, separado de `Calendar.tsx`, porque es la única
 * pieza del calendario que **se puede probar**: el resto es markup, y este
 * defecto no se ve mirando la pantalla. La versión anterior acotaba la hora al
 * rango de servicio,
 *
 *     Math.min(Math.max(h, START_HOUR), END_HOUR - 1)
 *
 * y con eso una visita de las 18:00 se dibujaba en la franja de las 16:00 sin
 * ningún aviso, y una de las 04:00 en la de las 05:00. El calendario mentía en
 * silencio, que es peor que dejar la visita afuera: quien lo miraba creía que
 * sabía a qué hora era.
 *
 * La cuadrícula sigue siendo 05:00–17:00. Ese es el horario de servicio del
 * negocio, no un límite de la pantalla, y no se amplía para que entre una
 * visita mal cargada. Lo que cambió es que lo que cae afuera se declara afuera.
 */

import { isWithinServiceWindow } from '@cleanblue/shared';

export type Slot =
  | { kind: 'hour'; hour: number }
  /** Sin hora. `scheduled_start` es nullable y hay visitas legítimas así. */
  | { kind: 'unscheduled' }
  /** Con hora, pero fuera del horario de servicio. */
  | { kind: 'outside' };

export function slotOf(visit: { scheduled_start: string | null }): Slot {
  if (!visit.scheduled_start) return { kind: 'unscheduled' };
  const hour = Number(visit.scheduled_start.slice(0, 2));
  if (Number.isNaN(hour)) return { kind: 'unscheduled' };
  if (!isWithinServiceWindow(visit.scheduled_start)) return { kind: 'outside' };
  return { kind: 'hour', hour };
}
